import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './style.scss';

class Checkbox extends Component {
    state = {};

    toggleCheckboxChange = () => {
        const { onChange, jsonKey } = this.props;
        onChange && onChange(jsonKey);
    };

    renderChecboxEnabledAndChecked = () => {
        return (
            <div
                className="checkbox-integrations checkbox-enabled-checked ic-thick"
                onClick={this.toggleCheckboxChange}
            />
        );
    };

    renderChecboxDisabledAndChecked = () => {
        return <div className="checkbox-integrations checkbox-disabled-checked ic-thick" />;
    };

    renderChecboxEnabledAndNotChecked = () => {
        return (
            <div className="checkbox-integrations ic-thick" onClick={this.toggleCheckboxChange} />
        );
    };

    renderChecboxDisabledAndNotChecked = () => {
        return <div className="checkbox-integrations checkbox-disabled ic-thick" />;
    };

    renderToggleEnabledAndChecked = () => {
        return (
            <div className="toogle-background-checked" onClick={this.toggleCheckboxChange}>
                <div className="toggle-enabled-checked" />
            </div>
        );
    };

    renderToggleEnabledAndNotChecked = () => {
        return (
            <div className="toogle-background" onClick={this.toggleCheckboxChange}>
                <div className="toggle-enabled" />
            </div>
        );
    };

    renderToggleDisabledAndNotChecked = () => {
        return (
            <div className="toogle-background-disabled">
                <div className="toggle-enabled" />
            </div>
        );
    };

    render() {
        const { label, isChecked, isDisabled, jsonKey, isToggle } = this.props;
        let checkbox = isToggle
            ? isChecked === 1 && !isDisabled
                ? this.renderToggleEnabledAndChecked()
                : isChecked === 0 && !isDisabled
                  ? this.renderToggleEnabledAndNotChecked()
                  : this.renderToggleDisabledAndNotChecked()
            : isChecked === 1 && !isDisabled
              ? this.renderChecboxEnabledAndChecked()
              : isChecked === 1 && isDisabled
                ? this.renderChecboxDisabledAndChecked()
                : isChecked === 0 && !isDisabled
                  ? this.renderChecboxEnabledAndNotChecked()
                  : this.renderChecboxDisabledAndNotChecked();
        let entityLabel = !isDisabled ? (
            <div className="entity-label">{label}</div>
        ) : (
            <div className="entity-label entity-label-disabled">{label}</div>
        );
        let content = isToggle ? (
            <div>
                {entityLabel}
                {checkbox}
            </div>
        ) : (
            <div>
                {checkbox}
                {entityLabel}
            </div>
        );
        return <div className="checkbox-entity-integrations-container">{content}</div>;
    }
}

Checkbox.propTypes = {
    label: PropTypes.string.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
};

export default Checkbox;
